import axios from 'axios';
export type TransactionStatus =
    | 'PENDING'
    | 'COMPLETED'
    | 'FAILED'
    | 'REFUNDED'
    | 'EXPIRED'
    | 'NEW';

export type CardSubMethod = "DEBIT" | "CREDIT";

export interface PixTransactionResponse {
    id: string;
    createdAt: string;
    expiresAt: string;
    status: TransactionStatus;
    qrCode?: string;
}

export interface GatewayErrorResponse {
    code: string;
    message: string;
    success: false;
}

export interface CardTransactionResponse extends PixTransactionResponse {
    qrCode: never;
}

const gatewayClient = axios.create({
    baseURL: import.meta.env.VITE_GATEWAY_URL,
    validateStatus: () => true,
});

const createPixTransaction = async (
    priceCents: number,
    saleId: number
) => {
    const response = await gatewayClient.post('/transaction/create', {
        priceCents,
        method: 'PIX',
        saleId,
        source: "STORE"
    });

    return response.data as PixTransactionResponse | GatewayErrorResponse;
};

const createCardTransaction = async (
    priceCents: number,
    subMethod: CardSubMethod,
    saleId: number,
    card: {
        expiry_date: string;
        number: string;
        security_code: string;
        brand: string;
    },
    installments: number,
) => {
    const response = await gatewayClient.post('/transaction/create-card', {
        priceCents,
        method: 'CARD',
        subMethod,
        saleId,
        card,
        installments,
        source: "STORE"
    });

    return response.data as CardTransactionResponse | GatewayErrorResponse;
};

const findTransaction = async (id: string) => {
    const response = await gatewayClient.get(`/transaction/${id}`);
    return response.data as { status: TransactionStatus };
};

const gatewayService = {
    createPixTransaction,
    findTransaction,
    createCardTransaction,
};

export default gatewayService;
